import React, { useEffect, useState } from 'react';
import ModalContainer from '../../components/ModalContainer.jsx';
import { Form, Formik } from 'formik';
import { initialValues, initialTouched, onSubmit, validationSchema } from './addUserFormikCodes.js';
import { useLocation, useNavigate, useOutletContext } from 'react-router-dom';
import GetField from '../../components/GetField.jsx';
import { getSingleAdminService, getSingleCustomerService } from '../../services/usersServices.js';
import Alert from '../../utils/Alert.js';
import { AllProvincesArray } from '../../Data/index.js';


const AddUser = () => {
    const [editingUser, setEditingUser] = useState(null);
    const [reinitializeValues, setReinitializeValues] = useState(null);

    const { setAdmins, isAdminMode, userRoles, setData } = useOutletContext();

    const navigate = useNavigate();
    const location = useLocation();

    const handleSetEditingUser = async (userId) => {
        let response;
        try {
            if (isAdminMode) {
                response = await getSingleAdminService(userId);
            } else {
                response = await getSingleCustomerService(userId);
            }
            if (response.status === 200) {
                setEditingUser(response.data);
            }
        } catch (error) {
            await Alert(`خطا ${error.response?.status || ""}!`, "در دریافت اطلاعات کاربر مشکلی رخ داده است!\nلطفاً مجدداً تلاش کنید.", "error");
            return navigate(-1);
        }
    }

    useEffect(() => {
        if (isAdminMode && userRoles.length === 0) {
            Alert("خطا!", "در دریافت نقش‌ها مشکلی رخ داده است!\nلطفاً صفحه را رفرش کنید.", "error");
            return navigate(-1);
        }

        if (location.state) {
            handleSetEditingUser(location.state.id);
        } else {
            setEditingUser(null);
        }

    }, []);

    useEffect(() => {
        if (editingUser) {
            setReinitializeValues({
                name: editingUser.name,
                family: editingUser.family,
                phone_number: editingUser.phone_number,
                email: editingUser.email,
                address: editingUser.address || "",
                address_code: editingUser.address_code || "",
                national_code: isAdminMode ? (editingUser.national_code || "") : "",
                commission_percentage: isAdminMode ? (editingUser.commission_percentage || 0) : 0,
                is_admin: isAdminMode,
                role: isAdminMode ? (editingUser.role || "") : "5",
                company_name: isAdminMode ? (editingUser.company_info?.name || "") : "",
                company_national_id: isAdminMode ? (editingUser.company_info?.national_id || "") : "",
                company_registration_number: isAdminMode ? (editingUser.company_info?.registration_number || "") : "",
                company_economic_code: isAdminMode ? (editingUser.company_info?.economic_code || "") : "",
                company_province: isAdminMode ? (editingUser.company_info?.province || "") : "",
                company_city: isAdminMode ? (editingUser.company_info?.city || "") : "",
                company_registration_address: isAdminMode ? (editingUser.company_info?.registration_address || "") : "",
                company_registration_phone_number: isAdminMode ? (editingUser.company_info?.registration_phone_number || "") : "",
                company_shaba: isAdminMode ? (editingUser.company_info?.shaba || "") : "",
                company_postal_code: isAdminMode ? (editingUser.company_info?.postal_code || "") : "",
                isEditing: true
            });
        } else {
            setReinitializeValues(null);
        }
    }, [editingUser]);

    return (
        <ModalContainer
            alwaysOpen={true}
            fullscreen={false}
            title={!location.state ?
                "افزودن ادمین" :
                isAdminMode ?
                    `ویرایش ادمین "${location.state.name} ${location.state.family}"` :
                    `ویرایش مشتری "${location.state.name} ${location.state.family}"`
            }
        >
            <Formik
                initialValues={reinitializeValues || initialValues}
                initialTouched={reinitializeValues ? initialTouched : {}}
                onSubmit={(values, actions) => onSubmit(values, actions, editingUser, setData, setAdmins, isAdminMode, navigate)}
                validationSchema={validationSchema}
                enableReinitialize
                validateOnMount
            >
                {(formik) => {
                    return (
                        <Form className="flex flex-col items-center">
                            {isAdminMode && <h1 className='mb-5 w-full md:w-3/5 max-w-screen-sm'>اطلاعات شخصی</h1>}
                            <div className="mb-5 w-full md:w-3/5 max-w-screen-sm">
                                <GetField
                                    control="input"
                                    name="name"
                                    type="text"
                                    placeholder="نام"
                                    label="نام"
                                    formik={formik}
                                />
                            </div>
                            <div className="mb-5 w-full md:w-3/5 max-w-screen-sm">
                                <GetField
                                    control="input"
                                    name="family"
                                    type="text"
                                    placeholder="نام خانوادگی"
                                    label="نام خانوادگی"
                                    formik={formik}
                                />
                            </div>
                            <div className="mb-5 w-full md:w-3/5 max-w-screen-sm">
                                <GetField
                                    control="input"
                                    name="phone_number"
                                    type="text"
                                    placeholder="شماره تلفن"
                                    label="شماره تلفن"
                                    formik={formik}
                                />
                            </div>
                            <div className="mb-6 w-full md:w-3/5 max-w-screen-sm">
                                <GetField
                                    control="input"
                                    name="email"
                                    type="text"
                                    placeholder="ایمیل"
                                    label="ایمیل"
                                    formik={formik}
                                />
                            </div>
                            {isAdminMode && (
                            <div className="mb-6 w-full md:w-3/5 max-w-screen-sm">
                                <GetField
                                    control="input"
                                    name="national_code"
                                    type="text"
                                    placeholder="کد ملی"
                                    label="کد ملی"
                                    formik={formik}
                                />
                            </div>
                            )}
                            {isAdminMode && <h1 className='mb-5 w-full md:w-3/5 max-w-screen-sm'>اطلاعات حقوقی</h1>}
                            {isAdminMode && (
                            <div className="mb-6 w-full md:w-3/5 max-w-screen-sm">
                                <GetField
                                    control="input"
                                    name="company_name"
                                    type="text"
                                    placeholder="نام"
                                    label="نام"
                                    formik={formik}
                                />
                            </div>
                            )}
                            {isAdminMode && (
                            <div className="mb-6 w-full md:w-3/5 max-w-screen-sm">
                                <GetField
                                    control="input"
                                    name="company_national_id"
                                    type="text"
                                    placeholder="شناسه ملی"
                                    label="شناسه ملی"
                                    formik={formik}
                                />
                            </div>
                            )}
                            {isAdminMode && (
                            <div className="mb-6 w-full md:w-3/5 max-w-screen-sm">
                                <GetField
                                    control="input"
                                    name="company_registration_number"
                                    type="text"
                                    placeholder="شماره ثبت"
                                    label="شماره ثبت"
                                    formik={formik}
                                />
                            </div>
                            )}
                            {isAdminMode && (
                            <div className="mb-6 w-full md:w-3/5 max-w-screen-sm">
                                <GetField
                                    control="input"
                                    name="company_economic_code"
                                    type="text"
                                    placeholder="کد اقتصادی"
                                    label="کد اقتصادی"
                                    formik={formik}
                                />
                            </div>
                            )}
                            {isAdminMode && (
                            <div className="mb-6 w-full md:w-3/5 max-w-screen-sm">
                                <GetField
                                    control="select"
                                    name="company_province"
                                    options={AllProvincesArray}
                                    label="استان:"
                                    title="استان را انتخاب کنید"
                                    formik={formik}
                                />
                            </div>
                            )}
                            {isAdminMode && (
                            <div className="mb-6 w-full md:w-3/5 max-w-screen-sm">
                                <GetField
                                    control="input"
                                    name="company_city"
                                    type="text"
                                    placeholder="شهر"
                                    label="شهر"
                                    formik={formik}
                                />
                            </div>
                            )}
                            {isAdminMode && (
                            <div className="mb-6 w-full md:w-3/5 max-w-screen-sm">
                                <GetField
                                    control="input"
                                    name="company_registration_address"
                                    type="text"
                                    placeholder="آدرس"
                                    label="آدرس"
                                    formik={formik}
                                />
                            </div>
                            )}
                            {isAdminMode && (
                            <div className="mb-6 w-full md:w-3/5 max-w-screen-sm">
                                <GetField
                                    control="input"
                                    name="company_registration_phone_number"
                                    type="text"
                                    placeholder="تلفن ثابت"
                                    label="تلفن ثابت"
                                    formik={formik}
                                />
                            </div>
                            )}
                            {isAdminMode && (
                            <div className="mb-6 w-full md:w-3/5 max-w-screen-sm">
                                <GetField
                                    control="input"
                                    name="company_shaba"
                                    type="text"
                                    placeholder="شماره شبا"
                                    label="شماره شبا"
                                    formik={formik}
                                />
                            </div>
                            )}
                            {isAdminMode && (
                            <div className="mb-6 w-full md:w-3/5 max-w-screen-sm">
                                <GetField
                                    control="input"
                                    name="company_postal_code"
                                    type="text"
                                    placeholder="کد پستی"
                                    label="کد پستی"
                                    formik={formik}
                                />
                            </div>
                            )}
                            {!isAdminMode && (
                            <div className="mb-5 w-full md:w-3/5 max-w-screen-sm">
                                <GetField
                                    control="textarea"
                                    name="address"
                                    placeholder="آدرس"
                                    label="آدرس:"
                                    rows={2}
                                />
                            </div>
                            )}
                            {!isAdminMode && (
                            <div className="mb-7 w-full md:w-3/5 max-w-screen-sm">
                                <GetField
                                    control="input"
                                    name="address_code"
                                    type="text"
                                    placeholder="کد پستی"
                                    label="کد پستی"
                                    formik={formik}
                                />
                            </div>
                            )}
                            {isAdminMode && (
                                <div className="mb-5 w-full md:w-3/5 max-w-screen-sm">
                                    <GetField
                                        control="select"
                                        name="role"
                                        options={userRoles.filter(ur => ur.value !== 1)}
                                        label="نقش ادمین:"
                                        title="نقش ادمین را انتخاب کنید"
                                        formik={formik}
                                    />
                                </div>
                            )}
                            {isAdminMode && (
                            <div className="mb-6 w-full md:w-3/5 max-w-screen-sm">
                                <GetField
                                    control="input"
                                    name="commission_percentage"
                                    type="number"
                                    placeholder="درصد کمیسیون"
                                    label="درصد کمیسیون"
                                    formik={formik}
                                />
                            </div>
                            )}
                            {!location.state && (
                                <>
                                    <div className="mb-5 w-full md:w-3/5 max-w-screen-sm">
                                        <GetField
                                            control="password"
                                            name="password"
                                            placeholder="رمز عبور"
                                            formik={formik}
                                        />
                                    </div>
                                    <div className="mb-5 w-full md:w-3/5 max-w-screen-sm">
                                        <GetField
                                            control="password"
                                            name="confirm_password"
                                            placeholder="تکرار رمز عبور"
                                            formik={formik}
                                        />
                                    </div>
                                </>
                            )}
                            <div className="w-full text-center mt-4">
                                <GetField
                                    control="submitbutton"
                                    formik={formik}
                                    text={!location.state ?
                                        "افزودن ادمین" :
                                        isAdminMode ?
                                            "ویرایش ادمین" :
                                            "ویرایش مشتری"
                                    }
                                />
                            </div>
                        </Form>
                    );
                }}
            </Formik>
        </ModalContainer>
    );
}

export default AddUser;
